import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

localStorage.removeItem("ei_customer_token");

export const customerApi = axios.create({ baseURL: API, withCredentials: true });
